<template>
    <el-card>
        <section>
            <!--工具条-->
            <el-col :span="24" class="form-line">
                <el-form size="small" :inline="true" :model="filters">
                    <el-form-item label="分类">
                        <el-select clearable v-model="filters.type" placeholder="请选择状态">
                            <el-option
                                    v-for="item in statusType"
                                    :key="item.id"
                                    :label="item.statusName"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select clearable v-model="filters.status" placeholder="请选择状态">
                            <el-option
                                    v-for="item in statusType2"
                                    :key="item.id"
                                    :label="item.statusName"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="内容">
                        <el-input v-model="filters.description" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <div style="float: right">
                        <el-form-item>
                            <el-button-group>
                                <el-button type="primary" icon="el-icon-search" @click="getMessageList()">查询</el-button>
                                <el-button icon="el-icon-refresh-right" @click="resetFilter()">重置</el-button>
                            </el-button-group>
                        </el-form-item>
                        <el-form-item>
                            <el-form-item label="联系电话" >
                                <el-input  v-model="phone" placeholder="联系电话" ></el-input>
                            </el-form-item>
                            <el-button-group>
                            <el-button type="primary" icon="el-icon-search" @click="editPhone()">保存</el-button>
                        </el-button-group>
                        </el-form-item>
                    </div>
                </el-form>
            </el-col>

            <!--列表-->
            <el-table border size="medium" :data="messageList" highlight-current-row v-loading="listLoading" @selection-change="selsChange">
                <el-table-column type="index" min-width="60">
                </el-table-column>
                <el-table-column prop="type" label="分类" min-width="120" :formatter="typeFormatter">
                </el-table-column>
                <el-table-column prop="description" label="内容" min-width="240">
                </el-table-column>
                <el-table-column prop="createDate" label="时间" min-width="120">
                </el-table-column>
                <el-table-column prop="status" label="状态" min-width="120" :formatter="statusFormatter">
                </el-table-column>
                <el-table-column label="操作" min-width="120">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewDetail(scope.row.id)">回复</el-button>
                        <!--<el-button v-if="scope.row.status === 1" type="text" size="small" @click="readMessage(scope.row.id)">确认已读</el-button>-->
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    style="padding: 15px 5px">
            </el-pagination>

            <!--新增界面-->
            <el-dialog title="详情" :visible.sync="addFormVisible" :close-on-click-modal="false">
                <el-form size="large" :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
                    <el-form-item label="求助说明">
                        <el-input type="textarea" readonly v-model="addForm.description"></el-input>
                    </el-form-item>
                </el-form>

                <div class="huifu-box" v-for="item in addForm.replyList" :key="item.id">
                    <div class="huifu-line">
                        <div class="huifu-name">
                            <img src="../../assets/head.png" alt="">
                            <span v-if="item.replyType === '1'">管理员</span>
                            <span v-if="item.replyType === '2'">求助人</span>
                        </div>
                        <div class="huifu-time">{{item.createDate}}</div>
                    </div>
                    <div class="huifu-line huifu-content">
                        {{item.content}}
                    </div>
                </div>

                <el-form size="large" :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
                    <el-form-item label="回复">
                        <el-input type="textarea" v-model="replyContent"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click.native="addFormVisible = false">取消</el-button>
                    <el-button size="small" type="primary" @click.native="addReply">继续回复</el-button>
                </div>
            </el-dialog>
        </section>
    </el-card>
</template>

<script>
/* eslint-disable */
import { doPost, download } from '../../api/api'

export default {
  data () {
    return {
      phone: '',
      sysDictId: '',
      filters: {
        systemFlag: 'service-mdinfo',
        description: '',
        type:'',
        status: ''
      },
      statusType: [
        { id: 1, statusName: '咨询' },
        { id: 2, statusName: '建议' },
        { id: 3, statusName: '投诉' }
      ],
        statusType2: [
            { id: 1, statusName: '未回复' },
            { id: 2, statusName: '已回复' }
        ],
      messageList: [],
      total: 0,
      listLoading: false,
      sels: [], // 列表选中列

      addFormVisible: false, // 新增界面是否显示
      addLoading: false,
      addFormRules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      // 新增界面数据
      addForm: {
          replyList: []
      },
      replyContent: '',
      messageTitle: '',
      messageSuc: '',
      value: '',
      value1: new Date(2016, 9, 10, 18, 40),
      value2: '',
      value3: '',
      user: {}
    }
  },
  methods: {
    getPhone () {
      var para = {
        dictType: 'phone'
      }
      doPost('/sysDict/getByEntity', para).then((res) => {
        console.log(res.result)
        this.phone = res.result.value1
        this.sysDictId = res.result.id
      })
    },
    handleSizeChange (val) {
      this.filters.pageSize = val
      this.getMessageList()
    },
    handleCurrentChange (val) {
      this.filters.pageNum = val
      this.getMessageList()
    },
    resetFilter () {
      Object.assign(this.$data.filters, this.$options.data().filters)
    },
    // 获取消息列表
    getMessageList () {
      this.loading = true
      doPost('/helpInfo/getPageList', this.filters).then((res) => {
        console.log(res.result)
        this.total = res.result.total
        this.messageList = res.result.list
        this.loading = false
      })
    },
    downloadUser () {
      // axios下载数据
      download('/user/downloadUser', this.filters, '用户数据.xls')
    },
    // 删除
    handleDel: function (index, row) {
    },
    // 显示新增界面
    handleAdd: function () {
      this.addFormVisible = true
      this.addForm = {
        systemFlag: 'service-mdinfo',
        roleName: '',
        description: ''
      }
      this.messageTitle = '新增'
      this.messageSuc = '新增成功'
    },
    readMessage (id) {
      var para = { id: id, status: 2 }
      doPost('/helpInfo/update', para).then((res) => {
        this.$message({
          message: '已读',
          type: 'success'
        })
        this.getMessageList()
      })
    },
    viewDetail(id){
        this.replyContent =  ''
        var para = {
            id: id
        }
        doPost('/helpInfo/getById', para).then((res) => {
            this.addForm = res.result
            this.addFormVisible = true
        })
    },
    // 全部已读
    editPhone () {
      var para = {
        id: this.sysDictId,
        value1: this.phone
      }
      doPost('/sysDict/update', para).then((res) => {
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.getMessageList()
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    // 批量删除
    batchRemove: function () {
    },
    statusFormatter (row, column) {
      if (row.status === 1) {
        return '未回复'
      } else if (row.status === 2) {
        return '已回复'
      }
    },
    addReply(){
        if(this.replyContent === ''){
            this.$message({
                message: '回复内容不能为空！',
                type: 'error'
            })
            return
        }
        this.$confirm('确认提交吗？', '提示', {}).then(() => {
            var para = {
                infoId: this.addForm.id,
                replyType: '1',
                content: this.replyContent
            }
            doPost('/helpInfoReply/insert', para).then((res) => {
                this.$message({
                    message: '回复成功',
                    type: 'success'
                })
                this.addFormVisible = false
                this.getMessageList()
            })
        })
    },
    typeFormatter (row, column) {
      if (row.type === 1) {
        return '咨询'
      } else if (row.type === 2) {
        return '建议'
      } else if (row.type === 3) {
        return '投诉'
      }
    }
  },
  mounted () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    this.getMessageList()
    this.getPhone()
  }
}

</script>

<style scoped>
    .huifu-box {
        padding: 10px 20px 10px 50px;
        margin-bottom: 20px;
    }

    .huifu-line {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .huifu-content {
        padding: 10px 10px 10px 50px;
    }

    .huifu-box img {
        width: 40px;
        height:40px;
        margin-right: 10px;
    }

    .huifu-name {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: bold;
    }

    .huifu-time {
        color: #aaa;
    }
</style>
